export const RETIREMENT = 'retirement';
export const DISABILITY = 'disability';
export const DEATH = 'death';

export type DashboardTypes = typeof RETIREMENT | typeof DISABILITY | typeof DEATH;
